import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://6460918bc828c96a486b952fdb700791@o58742.ingest.us.sentry.io/4509380724523008",

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
  sendDefaultPii: false, // because we want to be privacy focused

  integrations: [Sentry.browserTracingIntegration()],

  // Define how likely traces are sampled. Adjust this value in production,
  // or use tracesSampler for greater control.
  tracesSampleRate: 1.0,
});
